import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const internalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_INTERNAL_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_INTERNAL_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: { cacheLocation: "localStorage" },
};

const externalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_EXTERNAL_CLIENT_ID!,
    // Entra External ID uses ciamlogin.com, not login.microsoftonline.com.
    // knownAuthorities is required: MSAL v5 validates all authorities against
    // the standard Azure AD discovery endpoint by default, which fails for
    // ciamlogin.com. Listing the host here tells MSAL to trust it directly.
    authority: `https://${process.env.REACT_APP_EXTERNAL_TENANT_NAME}.ciamlogin.com/`,
    knownAuthorities: [`${process.env.REACT_APP_EXTERNAL_TENANT_NAME}.ciamlogin.com`],
    redirectUri: window.location.origin,
  },
  cache: { cacheLocation: "localStorage" },
};

export const msalInternal = new PublicClientApplication(internalConfig);
export const msalExternal = new PublicClientApplication(externalConfig);

// Scopes requested from each API registration
export const internalScopes = [
  `api://${process.env.REACT_APP_INTERNAL_API_CLIENT_ID}/api.read`,
];
export const externalScopes = [
  `api://${process.env.REACT_APP_EXTERNAL_API_CLIENT_ID}/api.read`,
];
